import { Component, type ErrorInfo, type ReactNode } from "react";

interface Props {
  children: ReactNode;
}

interface State {
  hasError: boolean;
  error: Error | null;
}

class ErrorBoundary extends Component<Props, State> {
  constructor(props: Props) {
    super(props);
    this.state = { hasError: false, error: null };
  }

  static getDerivedStateFromError(error: Error): State {
    return { hasError: true, error };
  }

  componentDidCatch(error: Error, errorInfo: ErrorInfo) {
    console.error("[ErrorBoundary] Caught error:", error, errorInfo);
  }

  handleReload = () => {
    // Unregister service workers to clear stale cache
    if ("serviceWorker" in navigator) {
      navigator.serviceWorker.getRegistrations().then((registrations) => {
        registrations.forEach((r) => r.unregister());
      });
    }
    // Clear caches
    if ("caches" in window) {
      caches.keys().then((names) => {
        names.forEach((name) => caches.delete(name));
      });
    }
    // Hard reload
    setTimeout(() => window.location.reload(), 300);
  };

  render() {
    if (this.state.hasError) {
      return (
        <div
          dir="rtl"
          style={{
            minHeight: "100vh",
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "center",
            padding: "2rem",
            background: "#0d1520",
            color: "#e0f2f1",
            fontFamily: "'Assistant', Arial, sans-serif",
            textAlign: "center",
          }}
        >
          <h1 style={{ fontSize: "2rem", marginBottom: "0.5rem" }}>
            🎁 NiceGift
          </h1>
          <p style={{ fontSize: "1.1rem", marginBottom: "1.5rem", color: "#9ca3af" }}>
            משהו השתבש בטעינת העמוד
          </p>
          <button
            onClick={this.handleReload}
            style={{
              background: "linear-gradient(135deg, #14b8a6, #0d9488)",
              color: "#fff",
              border: "none",
              borderRadius: "12px",
              padding: "14px 36px",
              fontSize: "1rem",
              fontWeight: 700,
              cursor: "pointer",
            }}
          >
            🔄 טען מחדש
          </button>
          <p
            style={{
              marginTop: "1.5rem",
              fontSize: "0.75rem",
              color: "#6b7280",
              maxWidth: "400px",
            }}
          >
            אם הבעיה חוזרת, נסה לנקות את הקאש של הדפדפן או לפתוח בגלישה פרטית
          </p>
        </div>
      );
    }

    return this.props.children;
  }
}

export default ErrorBoundary;
